// extracted by mini-css-extract-plugin
module.exports = {"container":"rich-text_container__1prJt"};